import { cn } from '@/lib/utils'
import type { SidebarSection } from '@/types/config'

interface SidebarSectionTabProps {
	tab: {
		key: SidebarSection
		label: string
		icon: string
		background: { active: string; inactive: string }
	}
	isActive: boolean
	onClick: () => void
}

export function SidebarSectionTab({ tab, isActive, onClick }: SidebarSectionTabProps) {
	return (
		<button
			type='button'
			onClick={onClick}
			aria-pressed={isActive}
			className={cn(
				'relative flex h-[50px] w-full items-center justify-center gap-1.5 rounded-xl border border-transparent bg-origin-border px-4 text-base font-semibold tracking-[-0.24px] transition-[color,box-shadow] duration-200 ease-in-out [background-clip:padding-box,border-box]',
				'after:absolute after:bottom-1 after:left-1/2 after:h-0.5 after:w-8 after:-translate-x-1/2 after:rounded-full after:bg-foreground after:transition-opacity after:duration-200 after:content-[""]',
				isActive ? tab.background.active : tab.background.inactive,
				isActive ? 'text-foreground after:opacity-100' : 'text-muted-foreground after:opacity-20',
			)}
		>
			<img src={tab.icon} alt='' className='h-8 w-8 shrink-0' draggable={false} />
			<span className='whitespace-nowrap'>{tab.label}</span>
		</button>
	)
}
